module.exports = __webpack_public_path__ + "static/media/BwAletaNo20-Black.aab583ea.ttf";